import classNames from "classnames";
import TooltipIcon from "PFComponents/tooltip_icon/tooltip_icon";
import React, { useState } from "react";

import css from "./warning_icons.module.scss";
import WarningTooltipContent from "./warning_tooltip_content";

interface IProps {
  label: string;
  counter: number;
  classes?: Record<string, string>;
  renderExpanded?: () => React.ReactNode;
  IconComponent: React.FC<{ width: number; height: number }>;
  height?: number;
  width?: number;
  iconColor?: string;
}

const WarningTooltipIcon = ({
  IconComponent,
  label,
  counter,
  classes = {},
  renderExpanded,
  height,
  width,
  iconColor
}: IProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const toggleExpanded = () => setExpanded((prev) => !prev);
  return (
    <TooltipIcon
      content={
        <WarningTooltipContent
          label={label}
          counter={counter}
          expanded={expanded}
          renderExpanded={renderExpanded}
          onToggleExpanded={toggleExpanded}
          classes={{
            counter: classes.counter
          }}
          iconColor={iconColor}
        />
      }
      IconComponent={IconComponent}
      className={classNames(css.iconRoot, classes.icon)}
      tooltipProps={{
        interactive: !!renderExpanded,
        onHidden: () => {
          setExpanded(false);
        },
        theme: "pf-translucent",
        maxWidth: 400
      }}
      height={height}
      width={width}
      iconColor={iconColor}
    />
  );
};

export default WarningTooltipIcon;
